import type { FunctionComponent } from 'react';

import type { FilesFileSchemaWithId } from '@iconik-io/iconik-api/src/services/files';

import { useAppSelector } from '../../../store/react_redux_typed';

type Props = {
  files: FilesFileSchemaWithId[];
};

const StorageNames: FunctionComponent<Props> = ({ files }) => {
  const storages = useAppSelector((state) => state.entities.storages);
  const formats = useAppSelector((state) => state.entities.formats);

  const isOriginalFormat = (file: FilesFileSchemaWithId) =>
    file.format_id && formats[file.format_id]?.name === 'ORIGINAL';

  const names = files
    .map((file) =>
      file.storage_id && isOriginalFormat(file)
        ? storages[file.storage_id]?.name
        : undefined,
    )
    .filter((name) => name);

  if (names.length === 0) {
    return null;
  }
  return <>{names.join(', ')}</>;
};

export default StorageNames;
